module.exports = __webpack_public_path__ + "img/01.0f262938.png";